module.exports = __webpack_public_path__ + "media/images/division-fa8c57b133d6e1fd3940bda809b1bdd6.svg";